module.exports = __webpack_public_path__ + "static/r27-fce99cf22e6b49cd87691d043daed8ab.jpg";